import Link from "next/link";
import { Session } from "next-auth";

import styles from "./NavBar.module.css";

type NavBarProps = {
  session: Session;
};

export default function NavBar({ session }: NavBarProps) {
  if (!session) {
    return null;
  }

  return (
    <div className="container">
      <nav className={`navbar navbar-light bg-light mb-3`}>
        <Link href="/">
          <a className="navbar-brand">
            <img src="/txdp.png" className={`me-2 ${styles.logoImage}`} />
            Launchpad
          </a>
        </Link>
        <div>
          <ul className="navbar-nav">
            <li className="nav-item">
              <span className="nav-link">{session?.user.name}</span>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}
